module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.dd5415b9.ttf";